import { Box, Flex, Text } from '@chakra-ui/react';
import DeadlinesCategoryConfigurations from './components/DeadlinesCategoryConfigurations';
import DeadlinesTipologyConfigurations from "./components/DeadlinesTipologyConfigurations";
import InterventionReportSettings from './components/InterventionReportSettings';
import ModelTypeConfigurations from './components/ModelTypeConfigurations';
import OperationsTipologyConfigurations from './components/OperationsTipologyConfigurations';
import VehiclesConfigurations from './components/VehiclesConfigurations';

export default function Configurations() {

    return (
        <Box pt={{ base: '70px', md: '70px', xl: '70px' }}>
            <Text pb={'30px'} color={"#9FB50C"} fontSize='xl' fontWeight='bold'>Gestione Scadenze</Text>
            <Flex mt='0px' direction={{ base: 'column', md: 'row' }} height='100%'>
                <Box flex='1' height='100%'>
                    <DeadlinesCategoryConfigurations />
                </Box>
                <Box flex='1' height='100%'>
                    <DeadlinesTipologyConfigurations />
                </Box>
            </Flex>
            <Text mt='30px' pb={'30px'} color={"#9FB50C"} fontSize='xl' fontWeight='bold'>Gestione Modelli</Text>
            <Flex direction={{ base: 'column', md: 'row' }} height='100%'>
                <Box flex='1' height='100%'>
                    <ModelTypeConfigurations />
                </Box>
                <Box flex='1' height='100%'>
                    <></>
                </Box>
            </Flex>
            <Text mt='30px' pb={'30px'}  color={"#9FB50C"} fontSize='xl' fontWeight='bold'>Gestione Interventi</Text>
            <Flex direction={{ base: 'column', md: 'row' }} height='100%'>
                <Box flex='1' height='100%'>
                    <OperationsTipologyConfigurations />
                </Box>
                <Box flex='1' height='100%'>
                    <VehiclesConfigurations />
                </Box>
            </Flex>
            <Text mt='30px' pb={'30px'} color={"#9FB50C"} fontSize='xl' fontWeight='bold'>Rapporti d'Intervento</Text>
            <InterventionReportSettings />
        </Box>
    );
}

